import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "aria-haspopup": "true",
  "aria-controls": "overlay_menu"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-down" }, null, -1)
const _hoisted_3 = ["href", "onClick"]
const _hoisted_4 = { class: "ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
      class: "section--selected"
    }, [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.user.firstName), 1),
      _hoisted_2
    ]),
    _createVNode(_component_Menu, {
      ref: "menu",
      id: "overlay_menu",
      model: _ctx.items,
      popup: true
    }, {
      item: _withCtx(({ item, props }) => [
        _createVNode(_component_router_link, {
          to: item.route,
          custom: ""
        }, {
          default: _withCtx(({ href, navigate }) => [
            _createElementVNode("a", _mergeProps({ href: href }, props.action, {
              onClick: navigate,
              class: "data--aligncenter aligndata--separate5"
            }), [
              _createElementVNode("span", {
                class: _normalizeClass(item.icon)
              }, null, 2),
              _createElementVNode("span", _hoisted_4, _toDisplayString(item.label), 1)
            ], 16, _hoisted_3)
          ]),
          _: 2
        }, 1032, ["to"])
      ]),
      _: 1
    }, 8, ["model"])
  ], 64))
}